<template>
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">
    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <!--begin::Toolbar container-->
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <!--begin::Title-->
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            منصة أكاديميا Academia
          </h1>
          <!--end::Title-->
          <!--begin::Breadcrumb-->
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary">الصفحة الرئيسية</a>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">دوراتي</li>
            <!--end::Item-->
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!-- Additional actions here if needed -->
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Toolbar container-->
    </div>
    <!--end::Toolbar-->
    <!--begin::Content-->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Row-->
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10" id="section-content">
          <!-- end main content-->
        </div>
      </div>
      <!--end::Content container-->
    </div>
    <!--end::Content-->
  </div>
</template>

<script>
import {
  apiUrl,
  courseImagePath,
  deviceId,
  getBrowserName,
  api_get,
  api,
  instructorImagePath,
} from "@/utils/api"; // Adjust the import path according to your project structure

export default {
  name: "AllCategory",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      respo: localStorage.getItem("respo"),
    };
  },
  mounted() {
    this.fetchCategories();
  },

  methods: {
    async fetchCategories() {
      try {
        const response = await fetch(`${apiUrl}/home/web`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-country-code": "+218",
          },
        });
        const jsonResponse = await response.json();

        const sectionContent = document.getElementById("section-content");
        sectionContent.innerHTML = "";

        const allCategories = jsonResponse.allcategory;

        allCategories.forEach((category) => {
          const subcategories = category.subcategory;
          const imgePath = "assets/img/acad-icon.png";

          const categoryElement = document.createElement("div");
          categoryElement.classList.add("col-xl-4", "col-lg-4", "col-md-4");

          const cardElement = document.createElement("div");
          cardElement.classList.add("card");

          const cardBodyElement = document.createElement("div");
          cardBodyElement.classList.add("card-body");

          const rowElement = document.createElement("div");
          rowElement.classList.add("row");

          const col7Element = document.createElement("div");
          col7Element.classList.add("col-9");

          const h5Element = document.createElement("h5");
          h5Element.textContent = category.title.en;

          const hrElement = document.createElement("hr");

          const mt3Element = document.createElement("div");
          mt3Element.classList.add("mt-3");

          const collapseButton = document.createElement("a");
          collapseButton.href = "#";
          collapseButton.classList.add(
            "m-2",
            "btn",
            "btn-success",
            "btn-sm",
            "collapsed"
          );
          collapseButton.setAttribute("data-bs-toggle", "collapse");
          collapseButton.setAttribute(
            "data-bs-target",
            `#category${category.id}-subcategory`
          );
          collapseButton.setAttribute("aria-expanded", "false");
          collapseButton.innerHTML = 'عرض <i class="fa-solid fa-arrow-left ms-1"></i>';

          /*const showButton = document.createElement('a');
                    showButton.href = `/CategoryCourses?value_id=category_id&value=${category.id}`;
                    showButton.classList.add('m-2', 'btn', 'btn-success', 'btn-sm', 'btn-acdemia');
                    showButton.setAttribute('aria-expanded', 'false');
                    showButton.innerHTML = 'عرض <i class="fa fa-list"></i>';*/
          const showButton = "";
          const col5Element = document.createElement("div");
          col5Element.classList.add("col-3", "ms-auto");

          const imgElement = document.createElement("img");
          imgElement.src = imgePath;
          imgElement.alt = "";
          imgElement.style.height = "72px";
          imgElement.style.maxWidth = "69px";

          imgElement.classList.add("img-fluid");

          const col12Element = document.createElement("div");
          col12Element.classList.add("col-12");

          const clearfixElement = document.createElement("div");
          clearfixElement.classList.add("clearfix");

          const ulElement = document.createElement("ul");
          ulElement.id = `category${category.id}-subcategory`;
          ulElement.classList.add(
            "list-group",
            "list-unstyled",
            "sortable-subcategory",
            "ui-sortable",
            "collapse"
          );

          mt3Element.append(collapseButton, showButton);
          col7Element.append(h5Element, hrElement, mt3Element);
          col5Element.append(imgElement);
          col12Element.append(clearfixElement, ulElement);
          rowElement.append(col7Element, col5Element, col12Element);
          cardBodyElement.append(rowElement);
          cardElement.append(cardBodyElement);
          categoryElement.append(cardElement);
          sectionContent.appendChild(categoryElement);

          subcategories.forEach((subcategory) => {
            const childCategories = subcategory.childcategory;

            const liElement = document.createElement("li");
            liElement.classList.add(
              "list-group-item",
              "subcategory-box",
              "ui-sortable-handle"
            );
            liElement.setAttribute("data-subcategory-id", subcategory.id);

            const subcategoryRowElement = document.createElement("div");
            subcategoryRowElement.classList.add("row");

            const subcategoryColElement = document.createElement("div");
            subcategoryColElement.classList.add("col-12");
            subcategoryColElement.style.textAlign = "right";

            const collapseSubcategoryButton = document.createElement("button");
            collapseSubcategoryButton.type = "button";
            collapseSubcategoryButton.classList.add(
              "btn",
              "btn-sm",
              "btn-outline",
              "btn-outline-success",
              "btn-collapse-subcategory",
              "mr-2",
              "btn-sm"
            );
            collapseSubcategoryButton.setAttribute("data-bs-toggle", "collapse");
            collapseSubcategoryButton.setAttribute(
              "data-bs-target",
              `#subcategory${subcategory.id}-childcat`
            );
            collapseSubcategoryButton.setAttribute("aria-expanded", "true");
            collapseSubcategoryButton.innerHTML =
              'المزيد <i class="fa fa-angle-down" aria-hidden="true"></i>';

            const showSubcategoryButton = document.createElement("a");
            showSubcategoryButton.href = `/CategoryCourses?value_id=subcategory_id&value=${subcategory.id}`;
            showSubcategoryButton.classList.add(
              "btn",
              "btn-outline",
              "btn-outline-primary",
              "btn-sm"
            );
            showSubcategoryButton.setAttribute("aria-expanded", "false");
            showSubcategoryButton.innerHTML =
              'عرض <i class="fa-solid fa-arrow-left"></i>';

            const subcategorySpanElement = document.createElement("div");
            subcategorySpanElement.style.width = "100%";
            subcategorySpanElement.textContent = subcategory.title;

            const subcategoryUlElement = document.createElement("ul");
            subcategoryUlElement.id = `subcategory${subcategory.id}-childcat`;
            subcategoryUlElement.classList.add(
              "list-group",
              "list-unstyled",
              "class-box",
              "sortable-childcategory",
              "ui-sortable",
              "collapse"
            );
            subcategoryUlElement.setAttribute("data-subcategory-id", subcategory.id);

            subcategoryColElement.append(
              subcategorySpanElement,
              collapseSubcategoryButton,
              showSubcategoryButton
            );
            subcategoryRowElement.append(subcategoryColElement);
            liElement.append(subcategoryRowElement, subcategoryUlElement);
            ulElement.appendChild(liElement);

            childCategories.forEach((childCategory) => {
              const childCategoryLiElement = document.createElement("li");
              childCategoryLiElement.classList.add(
                "list-group-item",
                "childcategory-box",
                "ui-sortable-handle"
              );
              childCategoryLiElement.setAttribute("data-class-id", childCategory.id);

              const childCategoryRowElement = document.createElement("div");
              childCategoryRowElement.classList.add("row");

              const childCategoryColElement = document.createElement("div");
              childCategoryColElement.classList.add("col-12");
              childCategoryColElement.style.textAlign = "right";

              const childCategorySpanElement = document.createElement("div");
              childCategorySpanElement.classList.add("ml-2");
              childCategorySpanElement.style.width = "100%";
              childCategorySpanElement.textContent = childCategory.title;

              const showChildCategoryButton = document.createElement("a");
              showChildCategoryButton.href = `/CategoryCourses?value_id=childcategory_id&value=${childCategory.id}&sub=${subcategory.id}`;
              showChildCategoryButton.classList.add(
                "m-1",
                "btn",
                "btn-outline",
                "btn-primary",
                "btn-sm"
              );
              showChildCategoryButton.setAttribute("aria-expanded", "false");
              showChildCategoryButton.innerHTML =
                'عرض <i class="fa-solid fa-arrow-left"></i>';

              childCategoryColElement.append(
                childCategorySpanElement,
                showChildCategoryButton
              );
              childCategoryRowElement.append(childCategoryColElement);
              childCategoryLiElement.append(childCategoryRowElement);
              subcategoryUlElement.appendChild(childCategoryLiElement);
            });
          });
        });
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    },
  },
};
</script>

<style scoped></style>
